/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ kg: NonNullable<unknown> }} Features_Train_Chip_LastInputs */

const en_features_train_chip_last = /** @type {(inputs: Features_Train_Chip_LastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.kg} kg on last time`)
};

const pl_features_train_chip_last = /** @type {(inputs: Features_Train_Chip_LastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.kg} kg od ostatniego razu`)
};

/**
* | output |
* | --- |
* | "+{kg} kg on last time" |
*
* @param {Features_Train_Chip_LastInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_train_chip_last = /** @type {((inputs: Features_Train_Chip_LastInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Train_Chip_LastInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_train_chip_last(inputs)
	return en_features_train_chip_last(inputs)
});